import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { articles } from "@/mocks/gossip";

const NAV_LINKS = [
  { label: "首页", to: "/" },
  { label: "猛料总汇", to: "/hot" },
  { label: "专题分类", to: "/topics" },
  { label: "关于我们", to: "/about" },
  { label: "常见问题", to: "/faq" },
  { label: "联系我们", to: "/contact" },
];

const TICKER_ITEMS = articles.filter((item) => item.hot).map((item) => item.title);

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const handleSearch = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = keyword.trim();
    if (!value) {
      return;
    }
    navigate(`/hot?q=${encodeURIComponent(value)}`);
    setKeyword("");
    setMenuOpen(false);
  };

  return (
    <header className="w-full sticky top-0 z-50">
      <div className="w-full bg-secondary-950 text-background-100">
        <div className="flex items-center gap-4 px-4 md:px-6 h-9 overflow-hidden">
          <span className="hidden sm:flex items-center gap-1.5 shrink-0 text-[11px] font-label font-medium tracking-wide text-accent-300">
            <i className="ri-flashlight-fill"></i>
            热榜速览
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex w-max animate-marquee whitespace-nowrap">
              {[0, 1].map((loop) => (
                <div key={loop} className="flex">
                  {TICKER_ITEMS.map((title, index) => (
                    <span
                      key={`${loop}-${index}`}
                      className="text-xs text-background-200/90 mr-8 font-label"
                    >
                      · {title}
                    </span>
                  ))}
                </div>
              ))}
            </div>
          </div>
          <Link
            to="/contact"
            className="hidden md:inline-flex items-center gap-1 shrink-0 text-[11px] text-accent-300 hover:text-accent-200 transition-colors cursor-pointer"
          >
            <i className="ri-megaphone-line"></i>
            我要爆料
          </Link>
        </div>
      </div>

      <div className="w-full bg-background-50/95 backdrop-blur border-b border-background-200">
        <div className="w-full px-4 md:px-6 h-16 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2.5 shrink-0 cursor-pointer" aria-label="看料吃瓜社首页">
            <span className="w-10 h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-xl">
              <i className="ri-chat-smile-2-line"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold text-foreground-950">看料吃瓜社</span>
              <span className="font-label text-[10px] tracking-[0.18em] text-foreground-500 mt-0.5">
                KANLIAO · CHIGUA
              </span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                className={({ isActive }) =>
                  `px-3 py-2 text-sm font-label rounded-md transition-colors whitespace-nowrap ${
                    isActive
                      ? "text-primary-700 bg-primary-100"
                      : "text-foreground-700 hover:text-primary-700 hover:bg-background-100"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <form onSubmit={handleSearch} className="hidden md:flex items-center" role="search">
              <label className="relative flex items-center">
                <i className="ri-search-line absolute left-3 text-foreground-400 text-sm pointer-events-none"></i>
                <input
                  value={keyword}
                  onChange={(event) => setKeyword(event.target.value)}
                  type="search"
                  name="keyword"
                  placeholder="搜瓜料、找时间线"
                  aria-label="站内搜索"
                  className="w-44 xl:w-56 pl-9 pr-3 py-2 text-sm font-label rounded-md bg-background-100 border border-background-200 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:bg-background-50 transition-colors"
                />
              </label>
            </form>

            <Link
              to="/hot"
              className="hidden md:inline-flex items-center gap-1.5 px-4 py-2 text-sm font-label font-medium rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-fire-line"></i>
              今日大瓜
            </Link>

            <button
              type="button"
              onClick={() => setMenuOpen((prev) => !prev)}
              aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
              aria-expanded={menuOpen}
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-200 text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-4">
            <form onSubmit={handleSearch} className="relative flex items-center mb-3" role="search">
              <i className="ri-search-line absolute left-3 text-foreground-400 text-sm pointer-events-none"></i>
              <input
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                type="search"
                name="keyword"
                placeholder="搜瓜料、找时间线"
                aria-label="站内搜索"
                className="w-full pl-9 pr-3 py-2.5 text-sm font-label rounded-md bg-background-100 border border-background-200 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
              />
            </form>
            <nav className="grid grid-cols-2 gap-2" aria-label="移动端导航">
              {NAV_LINKS.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  end={link.to === "/"}
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) =>
                    `px-3 py-2.5 text-sm font-label rounded-md text-center transition-colors ${
                      isActive
                        ? "bg-primary-100 text-primary-700"
                        : "bg-background-100 text-foreground-700 hover:bg-background-200"
                    }`
                  }
                >
                  {link.label}
                </NavLink>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}